<div class="offcanvas-header border-bottom">
  <h5 id="offcanvasLabel" class="fw-semibold mb-0">
    {{ 'Reviews for' | translate }} {{ clinicName ? clinicName : '' }}
  </h5>
  <button type="button" class="btn-close no-drag" (click)="closeOffcanvas()"></button>
</div>

<div class="offcanvas-body p-0">

  <div *ngIf="!loadingReviews" class="reviews-container">
    <div class="border-bottom p-3 bg-light">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-2">
          <app-rating-badge *ngIf="hasReviews" [averageRate]="averageRating"></app-rating-badge>
          <span class="text-muted small">
            {{reviewsLabel}}</span>
        </div>
        <button class="btn btn-primary btn-sm d-flex align-items-center justify-content-center mt-1 w-auto gap-1 p-2"
          type="button" (click)="openWriteReviewModal('open-write-review')">
          <i class="bi bi-pencil"></i>
          <p class="m-0">{{'Write review' | translate}}</p>
        </button>
      </div>
    </div>

    <div class="reviews-list pt-3">

      <div class="px-3">
        <app-review-summary [showInRows]="true" style="flex: 1 1 300px;" [reviewStats]="reviewStats" [viewStatus]="viewStatus"></app-review-summary>

      </div>
      <hr class="separator">
      <div class="px-3 pt-1">
        <app-rating-breakdown [showInRows]="true" [reviewStats]="reviewStats" [viewStatus]="viewStatus"></app-rating-breakdown>
      </div>
      <hr class="separator mb-0">

      <ng-container *ngFor="let review of displayedReviews; trackBy: trackByReviewId; let i = index">
        <div class="review-item p-3 border-bottom">
          <app-review [showFullReview]="true" [review]="review" class="pointer"></app-review>
          <div *ngIf="i === displayedReviews.length - 1" #lastReview></div>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="loadingReviews" class="text-center p-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading reviews...</span>
    </div>
  </div>
</div>